import React, { forwardRef } from 'react'
import { css, cx } from '@linaria/core'
import BaseButton from './BaseButton'
import { fonts } from '../theme'
import Ellipsis from '../ellipsis'

import type { TextButtonProps } from './types'

const textButtonCss = css`
  font-family: ${fonts.body};
  // Prevent Ellipsis overriding with block when deployed
  display: inline-block !important;
  text-align: start;

  width: fit-content;

  -webkit-touch-callout: none;
  line-height: 1;

  /** NOT SUPPORTED YET:
  *    font-smoothing: antialiased;
  * We have this because when things get transformed, they get aliased by some browsers.
  * This makes things look a little blurry, so we turn on font-smoothing to make it look
  * better. However, this is not supported in all browsers, so we have to use the
  * vendor-prefixed versions. When this is supported in all browsers, we can remove
  * the vendor-prefixed versions.
  */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; /* yes this will ONLY work on the Mac Firefox - Windows is out of luck */
`

const TextButton = forwardRef(
  (
    { text, children, className, description, disabled, disabledDescription = description, ...props }: TextButtonProps,
    ref
  ) => (
    <Ellipsis
      {...props}
      as={BaseButton}
      label={text}
      className={cx(className, textButtonCss)}
      ref={ref}
      disabled={disabled}
      description={disabled ? disabledDescription : description}
    >
      {children}
    </Ellipsis>
  )
)

export default TextButton
